import script from "./LearningCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./LearningCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./LearningCalendar.vue?vue&type=style&index=0&id=51a28474&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51a28474"]])

export default __exports__